// @ts-nocheck
// import { Slash } from "@insite/mobius/Breadcrumbs"; // Store Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        typographyProps: {
            color: "inherit",
            size: "inherit",
        },
        css: css`
            ${siteWidthStyles()}
            /* Store Custom Code - Start */
            ol {
                position: relative;
                padding: ${pxToRem(16)};
                margin: 0 -${pxToRem(16)} 0 -${pxToRem(16)};
                display: flex;
                flex-wrap: nowrap;
                overflow: hidden;
            }
            
            ol::after {
                content: "";
                position: absolute;
                bottom: 0;
                height: 1px;
                width: calc(100% - ${pxToRem(32)});
                background-color: ${getColor("common.border")};
            }

            li {
                flex-shrink: 0;
            }

            .ellipsis {
                display: none;
                color: ${getColor("secondary.main")};
                font-weight: ${x => x.theme.design.typography.weight.bold};
            }

            li:last-child {
                flex-shrink: 1;
                flex-grow: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            /* Store Custom Code - End */

            ${x =>
                breakpointValues(
                    [x.theme.design.typography.size.smallest, x.theme.design.typography.size.smaller, null, null, null],
                    "font-size",
                )}

            /* Store Custom Code - Start */
            a + span {
                margin-left: ${pxToRem(12)};
                margin-right: ${pxToRem(12)};
                height: 0;
            }
            svg {
                position: relative;
                bottom: -${pxToRem(4)};
            }
            /* Store Custom Code - End */

            a {
                ${linkStyles("inherit", "text.linkAltHover", false, false)}
            }

            [aria-current="page"] {
                color: ${getColor("secondary.main")}; /* Store Custom Code */
                font-weight: ${x => x.theme.design.typography.weight.black}; /* Store Custom Code */
            }

            /* Store Custom Code - Start */
            ${breakpoint("xs", "down")} {
                margin-left: 0;
                margin-right: 0;
                padding-left: 0;
                padding-right: 0;

                ol {
                    ${siteWidthStyles()}
                }

                ol::after {
                    width: 100%;
                    left: 0;
                }

                a span {
                    max-width: 6em;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }

                li:last-child a span {
                    max-width: auto;
                }

                .needEllipsis li {
                    display: none;
                }

                .needEllipsis .ellipsis {
                    display: inline-block;
                }

                .needEllipsis li:first-child a {
                    display: none;
                }

                .needEllipsis li:first-child .ellipsis a {
                    display: inline-block;
                }

                .needEllipsis li:first-child,
                .needEllipsis li:nth-last-child(1),
                .needEllipsis li:nth-last-child(2) {
                    display: inline-block;
                }
            }
            /* Store Custom Code - End */
        `,
    },
};

export default breadcrumbs;
